import React from 'react'
import Logo from '../media/logo.png'

export const Contenido = () => {
    return (
        <div className='Contenido'>
            <div className="c">
                <img src={Logo} alt="Logo" />
                <div className="texto">
                    <h1>The Moon Proyect</h1>
                    <h3>Un podcast de entretenimiento</h3><br />
                    <h4><a href="">Canal de YouTube</a> <a href="">Ver Más</a></h4>
                </div>
            </div>
        </div>
    )
}
